import { TableCell, TableRow } from "@/components/ui/table";
import { cn } from "@/lib/utils";
import { useNavigate, UseNavigateResult } from "@tanstack/react-router";
import { Table, flexRender } from "@tanstack/react-table";
import { AppTable } from "../../types/app.type";
import { GetDeployingStatus } from "../QuickCreateApp/DeployingAppStatus/GetDeployingStatus";
import { columns } from "./Columns";

type Props<TData> = {
  table: Table<TData>;
};

export const AppTableBody = <TData extends AppTable>({
  table
}: Props<TData>) => {
  const navigate = useNavigate();

  return table.getRowModel().rows?.length ? (
    table.getRowModel().rows.map((row) => {
      const { isNewApp, isNewAppDisabled, isDeployingNewApp } =
        GetDeployingStatus(row.original.id);
      return (
        <TableRow
          onClick={
            isNewAppDisabled || isDeployingNewApp
              ? undefined
              : () => rowClick(row.original, navigate)
          }
          className={cn(
            "h-16 group",
            isNewApp &&
              "ring-1 ring-offset-1 ring-inset ring-primary dark:ring-brand-primary/50 bg-primary/20 dark:bg-brand-primary/20",
            isNewAppDisabled || isDeployingNewApp
              ? "cursor-not-allowed"
              : "cursor-pointer"
          )}
          key={row.id}
          data-state={row.getIsSelected() && "selected"}
          data-testid="appRow"
        >
          {row.getVisibleCells().map((cell) => (
            <TableCell className="first:w-16" key={cell.id}>
              {flexRender(cell.column.columnDef.cell, cell.getContext())}
            </TableCell>
          ))}
        </TableRow>
      );
    })
  ) : (
    <TableRow>
      <TableCell colSpan={columns.length} className="h-16 text-center">
        No results.
      </TableCell>
    </TableRow>
  );
};

function rowClick(row: AppTable, navigate: UseNavigateResult<string>) {
  switch (row.origin) {
    case "public":
      return window.open(row.link, "_blank")?.focus();
    case "organization":
      return navigate({
        to: "/organization/$organizationSlug/private/$appSlug",
        params: (prev) => ({
          organizationSlug: prev.organizationSlug || "",
          appSlug: row.slug || ""
        })
      });
    case "subscription":
      return navigate({
        to: "/organization/$organizationSlug/subscription/$subscriptionId",
        params: (prev) => ({
          organizationSlug: prev.organizationSlug || "",
          subscriptionId: row.subscription?.id || ""
        })
      });
    default:
      return console.error("not able to identify app row type");
  }
}
